module.exports = __webpack_public_path__ + "img/clock.b0a36bc8.svg";